import { render, staticRenderFns } from "./SupplierSizeDeviationCreateOrUpdateDialog.vue?vue&type=template&id=2e205199"
import script from "./SupplierSizeDeviationCreateOrUpdateDialog.ts?vue&type=script&lang=ts&external"
export * from "./SupplierSizeDeviationCreateOrUpdateDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports